import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import React from "react"

export default function TrendingCard({ title, image, slug }) {
  return (
    <div className="grid h-56 lg:h-72">
      <div className="col-start-1 row-start-1 relative z-0 h-56 lg:h-72">
        {image ? (
          <GatsbyImage
            image={image}
            alt={title}
            className="h-56 lg:h-72 w-full object-cover"
          />
        ) : (
          <StaticImage
            alt="trending"
            className="h-56 lg:h-72 w-full object-cover"
            src="https://images.unsplash.com/photo-1495562569060-2eec283d3391?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80"
          />
        )}
      </div>
      <Link
        to={slug}
        className="col-start-1 row-start-1 relative z-10 text-white font-bold h-56 lg:h-72 bg-black bg-opacity-25 hover:transition hover:ease-in-out hover:duration-300 hover:bg-opacity-70 flex items-center justify-center"
      >
        <h3>{title}</h3>
      </Link>
    </div>
  )
}
